<script lang="ts">
</script>

<div class="mt-8">
    <button
        onclick={() => window.history.pushState({}, '', '/')}
        class="btn btn-error btn-lg w-full text-xl"
    >
        Sair
    </button>
</div>